export const API_BASE_URL = process.env["REACT_APP_API_BASE_URL"] || "";

export const BASE_URL = "https://publisher.coinis.com/";

export const RECAPTCHA = "6Lcmqh4gAAAAAJhF12kIHFBP4g5smWNUgUzSxZsw";
